const TRANSLATION = {
  buyModal: {
    afterFree: 'หลังจากทดลองใช้ฟรีของคุณ',
    btn: 'ลองฟรี',
    freeTrial: 'ทดลองใช้ฟรี 3 วัน',
    monthLabel: 'เดือน',
    selectLabel: 'เลือกแผน',
    title: 'แผนการสมัครสมาชิก',
    yearLabel: 'ปี',
  },
  contact: {
    block1:
      'สำหรับการปรับแต่งคำถามหรือข้อเสนอแนะโปรดติดต่อเราที่ contact@noam.tools เราจะตอบกลับทันที',
    block2: 'สนับสนุนเราโดยให้คะแนนเราในร้านค้าส่วนขยาย Google Apps ที่★★★★★',
    block3: 'ช่วยผู้อื่นโดยการแบ่งปันส่วนขยายนี้:',
    title: 'ติดต่อเรา',
  },
  help: {
    AquickOverviewOfNoam: 'ภาพรวมอย่างรวดเร็วของ noam',
    ChatPDF: 'แชท pdf',
    ChatPDF2: 'chatpdf',
    FavoritesManagement: 'การจัดการรายการโปรด',
    Fixedplugin: 'ปลั๊กอินคงที่',
    Focusing: 'การโฟกัส',
    Free: 'ฟรี',
    FreeTrialBenefits: 'ผลประโยชน์ทดลองใช้ฟรี',
    GoWithWikipedia: 'ไปกับวิกิพีเดีย',
    GoWithYouTube: 'ไปกับ youtube',
    HoverTranslation: 'การแปลโฮเวอร์',
    Howtouse: 'วิธีใช้',
    ImageTranslation: 'การแปลภาพ',
    InstantTranslation: 'การแปลทันที',
    Membership: 'การเป็นสมาชิก',
    NoamHelp: 'Noam ช่วยให้คุณแปลและสรุป',
    PDFparallelTranslation: 'การแปลแบบขนาน PDF',
    ParallelTranslation: 'การแปลแบบขนาน',
    SkipAllSteps: 'ข้ามทุกขั้นตอน',
    Summary: 'สรุป',
    Translation: 'การแปล',
    TryItForFree: 'ลองฟรี',
    Video: 'วิดีโอ',
    VideoSummary: 'สรุปวิดีโอ',
    VideoTranslation: 'การแปลวิดีโอ',
    WebSummary: 'สรุปเว็บ',
    WordSelectionTranslation: 'คำแปลการเลือกคำ',
    benefits: 'เรามีประโยชน์รอคุณอยู่!',
    dayFree: 'ทดลองใช้ฟรี 3 วัน',
    done: 'เสร็จแล้ว',
    next: 'ต่อไป',
    pin: 'pin noam เพื่อการเข้าถึงที่ง่ายขึ้น ～～',
    planIsNotExist: 'ไม่มีแผน',
    startWiki: 'เริ่มต้นด้วย Wikimedia กันเถอะ!',
    startYoutube: 'เริ่มต้นด้วย YouTube กันเถอะ!',
    try: 'ลองดู',
    tryNow: 'ลองตอนนี้!',
  },
  home: {
    PDFTranslate: {
      desc: 'การแปลสองภาษา + แชท pdf',
      sub1: {
        desc: 'การอ่านสองภาษาช่วยให้คุณเปรียบเทียบข้อความต้นฉบับและการแปลแบบเคียงข้างกันปรับปรุงประสิทธิภาพการอ่าน',
        title: 'การอ่านสองภาษา',
      },
      sub2: { desc: 'AI วิเคราะห์และสรุปและสามารถตอบคำถามของคุณตามเนื้อหา PDF', title: 'แชท pdf' },
      sub3: {
        desc: 'การแปล PDF ที่ขับเคลื่อนด้วย AI เพื่อความแม่นยำและประสิทธิภาพที่มากขึ้น',
        title: 'ความแม่นยำและประสิทธิภาพ',
      },
      title: 'PDF แปล',
    },
    aiAssistant: {
      desc: 'ทำให้การแปลเว็บอย่างชาญฉลาดและสะดวกยิ่งขึ้น',
      panel1: {
        desc: 'การแปลการอ้างอิงข้ามสองภาษาช่วยให้คุณเปรียบเทียบข้อความต้นฉบับกับการแปลเพื่อให้คุณสามารถเข้าใจได้ดีขึ้นและปรับปรุงประสิทธิภาพการอ่านของคุณ',
        title: 'การแปลสองภาษา',
      },
      panel2: {
        left: {
          desc: 'เมื่อเรียกดูเว็บเพจให้วางเมาส์เหนือเนื้อหาที่คุณต้องแปลเพื่อดูการแปล',
          title: 'การแปลโฮเวอร์',
        },
        right: {
          desc: 'เมื่อเรียกดูหน้าเว็บให้เลือกข้อความที่คุณต้องการแปลเพื่อดูการแปล',
          title: 'การแปลการเลือกข้อความ',
        },
      },
      panel3: {
        one: {
          desc: 'แปลและสรุปหน้าเว็บและเนื้อหาวิดีโอทุกที่ทุกเวลาเพื่อประสบการณ์ที่ราบรื่นขึ้น!',
          title: 'จุดและคลิก',
        },
        three: {
          desc: 'รูปแบบภาษาขนาดใหญ่ที่ขับเคลื่อนด้วย AI ช่วยให้มั่นใจได้ถึงความแม่นยำในการแปลและความสอดคล้องสำหรับประสบการณ์การอ่านที่เพิ่มขึ้น',
          title: 'AI ขับเคลื่อน',
        },
        two: {
          desc: 'การครอบคลุมแบบเต็มหลายภาษาการอ่านแบบไม่มีกำแพงสองภาษาการแปลแบบคลิกเดียว-สัมผัสกับความแตกต่าง!',
          title: 'ครอบคลุมและสะดวกยิ่งขึ้น',
        },
      },
      panel4: {
        tab1: {
          desc: 'ผู้เชี่ยวชาญด้านประสิทธิภาพของคุณ - การใช้ CHATGPT, NOAM แปลและสรุปเนื้อหาวิดีโอ YouTube เพื่อประหยัดเวลา!',
          key: 'วิดีโอ',
          title: 'การแปลวิดีโอและสรุป',
        },
        tab2: { desc: 'คลิกเพื่อแปลภาพขณะท่องเว็บ', key: 'ภาพ', title: 'ภาพแปลภาพ' },
        tab3: {
          desc: 'แยกข้อมูลคีย์จากหน้าเว็บทันทีและให้ข้อมูลสรุปเพิ่มประสิทธิภาพการอ่านของคุณ',
          key: 'เว็บ',
          title: 'เว็บแปลและสรุป',
        },
        tag1: 'เรียบง่าย',
        tag2: 'มีประสิทธิภาพ',
        tag3: 'เข้าใจง่าย',
      },
      title: 'ผู้ช่วย AI',
    },
    getStart: 'เริ่มต้นใช้งาน',
    getStartedForFree: 'เริ่มต้นฟรี',
    howItWork: {
      desc: 'NOAM รวมโมเดล AI เพื่อให้ผู้ใช้ได้รับประสบการณ์อัจฉริยะสำหรับการแปลและการสรุปหน้าเว็บข้ามภาษาและการแปลภาพการแปลวิดีโอและการสรุป',
      title: 'มันทำงานอย่างไร',
    },
    lastBlock: { desc: 'การแปล AI ที่ดีขึ้นสำหรับประสบการณ์การอ่านที่ราบรื่นยิ่งขึ้น' },
    top: {
      desc: 'Noam เป็นส่วนขยายของเบราว์เซอร์ AI ฟรีที่ช่วยให้คุณแปลและสรุปหน้าเว็บวิดีโอและเนื้อหา PDF \\ n เข้าร่วม noam และสัมผัสกับเวทมนตร์!',
      title1: 'หนึ่งเวทมนตร์',
      title2: 'คลิกเดียว',
    },
    userReviews: { desc: 'บทวิจารณ์ระดับห้าดาวใน Chrome Web Store', title: 'บทวิจารณ์ผู้ใช้' },
  },
  installTips: {
    btn: 'ลองเลย',
    text: 'ติดตั้ง "ปลั๊กอินเบราว์เซอร์ NOAM" เพื่อปลดล็อกคุณสมบัติเพิ่มเติม! การอ้างอิงเว็บข้ามเว็บการสรุปวิดีโอเว็บและอีกมากมาย!',
  },
  locale: {
    af: 'ชาวแอฟริกัน',
    am: 'อัมฮาริก',
    ar: 'ภาษาอาหรับ',
    as: 'อัสสัม',
    auto: 'ตรวจจับอัตโนมัติ',
    az: 'อาเซอร์ไบจัน',
    ba: 'Bashkir',
    bg: 'ชาวบัลแกเรีย',
    bn: 'บางลา',
    bo: 'ชาวทิเบต',
    bs: 'ชาวบอสเนีย',
    ca: 'คาตาลัน',
    cs: 'ภาษาเช็ก',
    cy: 'ชาวเวลส์',
    da: 'เกี่ยวกับเดนมาร์ก',
    de: 'ชาวเยอรมัน',
    dsb: 'Sorbian ล่าง',
    dv: 'ดำน้ำ',
    el: 'กรีก',
    en: 'ภาษาอังกฤษ',
    es: 'เกี่ยวกับภาษาสเปน',
    et: 'เอสโตเนีย',
    eu: 'เกี่ยวกับบาสก์',
    fa: 'ชาวเปอร์เซีย',
    fi: 'ภาษาฟินแลนด์',
    fil: 'ชาวฟิลิปปินส์',
    fj: 'ชาวฟิจิ',
    fr: 'ภาษาฝรั่งเศส',
    frCA: 'ฝรั่งเศส (แคนาดา)',
    ga: 'เกี่ยวกับไอริช',
    gl: 'กาลิเซีย',
    gom: 'Konkani',
    gu: 'รัฐคุชราต',
    ha: 'เฮาซา',
    he: 'ภาษาฮีบรู',
    hi: 'ภาษาฮินดี',
    hr: 'เกี่ยวกับภาษาโครเอเชีย',
    hsb: 'Sorbian ตอนบน',
    ht: 'ชาวเฮติครีโอล',
    hu: 'ชาวฮังการี',
    hy: 'เกี่ยวกับอาร์เมเนีย',
    id: 'ชาวอินโดนีเซีย',
    ig: 'igbo',
    ikt: 'inuinnaqtun',
    is: 'เกี่ยวกับไอซ์แลนด์',
    it: 'อิตาลี',
    iu: 'inuktitut',
    iuLatn: 'Inuktitut (ละติน)',
    ja: 'ญี่ปุ่น',
    ka: 'ชาวจอร์เจีย',
    kk: 'คาซัค',
    km: 'เขมรตัว',
    kmr: 'เคิร์ด (ภาคเหนือ)',
    kn: 'ภาษากันนาดา',
    ko: 'เกาหลี',
    ku: 'เคิร์ด (กลาง)',
    ky: 'คีร์กีซ',
    ln: 'Lingala',
    lo: 'ลาว',
    lt: 'เกี่ยวกับลิทัวเนีย',
    lug: 'กานดา',
    lv: 'เกี่ยวกับลัตเวีย',
    lzh: 'ภาษาจีน (วรรณกรรม)',
    mai: 'maithili',
    mg: 'มาลากาเซ',
    mi: 'ชาวเมารี',
    mk: 'ชาวมาซิโดเนีย',
    ml: 'มาลายาลัม',
    mnCyrl: 'มองโกเลีย (Cyrillic)',
    mnMong: 'มองโกเลีย (ดั้งเดิม)',
    mr: 'มาราธี',
    ms: 'มลายู',
    mt: 'ภาษามอลตา',
    mww: 'ม้งดอว์',
    my: 'พม่า (พม่า)',
    nb: 'นอร์เวย์',
    ne: 'เนปาล',
    nl: 'ชาวดัตช์',
    noSearchLang: 'ไม่รองรับภาษา',
    nso: 'Sesotho sa leboa',
    nya: 'Nyanja',
    or: 'Odia',
    otq: 'Querétaro Otomi',
    pa: 'ปัญจาบ',
    pl: 'ขัด',
    placeholder: 'ค้นหา',
    prs: 'Dari',
    ps: 'Pashto',
    pt: 'โปรตุเกส (บราซิล)',
    ptPT: 'โปรตุเกส (โปรตุเกส)',
    ro: 'เกี่ยวกับโรมาเนีย',
    ru: 'ชาวรัสเซีย',
    run: 'Rundi',
    rw: 'Kinyarwanda',
    sd: 'ซินธี',
    si: 'Sinhala',
    sk: 'ชาวสโลวะเกีย',
    sl: 'สโลวีเนีย',
    sm: 'ประเทศซามัว',
    sn: 'โชนา',
    so: 'โซมาเลีย',
    sq: 'ชาวแอลเบเนีย',
    srCyrl: 'เซอร์เบีย (ซีริลลิก)',
    srLatn: 'เซอร์เบีย (ละติน)',
    st: 'Sesotho',
    sv: 'ภาษาสวีเดน',
    sw: 'ภาษาสวาฮิลี',
    ta: 'ทมิฬ',
    te: 'เตลูกู',
    th: 'แบบไทย',
    ti: 'ERROR: [Tigrinya]',
    tk: 'ชาวเติร์กเมน',
    tlhLatn: 'Klingon (ละติน)',
    tlhPiqd: 'Klingon (Piqad)',
    tn: 'setswana',
    to: 'ตองกา',
    tr: 'ตุรกี',
    tt: 'ตาตาร์',
    ty: 'ชาวตาฮิติ',
    ug: 'uyghur',
    uk: 'ชาวยูเครน',
    ur: 'ภาษาอูรดู',
    uz: 'อุซเบก (ละติน)',
    vi: 'เวียดนาม',
    xh: 'โซซา',
    yo: 'โยรูบา',
    yua: 'Yucatec Maya',
    yue: 'กวางตุ้ง (ดั้งเดิม)',
    zh: 'ชาวจีน',
    zhHans: 'ภาษาจีนเรียบง่าย',
    zhHant: 'แบบดั้งเดิมของจีน',
    zu: 'ซูลู',
  },
  login: {
    and: 'และ',
    btn: 'เข้าสู่ระบบด้วย Google',
    btn1: 'เข้าสู่ระบบตอนนี้',
    desc: 'เข้าสู่ระบบเพื่อปลดล็อกประสบการณ์เพิ่มเติม',
    policy: 'นโยบายความเป็นส่วนตัว',
    terms: 'ข้อกำหนดการใช้งาน',
    tips: 'โดยการลงทะเบียนฉันเห็นด้วยกับไฟล์',
    title: 'ยินดีต้อนรับสู่ Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'ติดตาม', twitter: 'Twitter' },
    legal: { policy: 'นโยบายความเป็นส่วนตัว', terms: 'ข้อกำหนด', title: 'ถูกกฎหมาย' },
    product: {
      image: 'การแปลภาพ',
      pdf: 'การแปล PDF',
      title: 'สินค้า',
      video: 'การแปลวิดีโอและสรุป',
      web: 'การแปลเว็บและสรุป',
    },
    resources: { title: 'ทรัพยากร' },
    tools: { title: 'เครื่องมือ', pdf: 'การแปล PDF' },
  },
  pageHeader: {
    contact: 'ติดต่อ',
    help: 'ช่วย',
    logout: 'ออกจากระบบ',
    logoutSucc: 'ออกจากระบบ',
    pricing: 'การกำหนดราคา',
    settings: 'การตั้งค่า',
    signUp: 'เข้าสู่ระบบ',
  },
  pdf: {
    autoDetect: 'ERROR: [Auto-Detect]',
    cancelBtn: 'ยกเลิก',
    cancelUpload: 'ยกเลิก',
    chatPdf: {
      summaryError: 'สรุปล้มเหลวโปรดลองอีกครั้งในภายหลัง',
      chatError: 'แชทล้มเหลวโปรดลองอีกครั้งในภายหลัง',
      Search: 'ค้นหา',
      cancel: 'ยกเลิก',
      chatTitle: 'ยินดีต้อนรับสู่ Noam! นี่คือบทสรุปของ PDF ของคุณ:',
      clear: 'ชัดเจน',
      clearContent: 'สิ่งนี้จะเริ่มการสนทนาใหม่ บทสนทนาปัจจุบันจะไม่ถูกบันทึก คุณแน่ใจหรือไม่?',
      clearDialogTitle: 'โปรดยืนยัน',
      clearSucc: 'เคลียร์',
      copy: 'สำเนา',
      copySucc: 'คัดลอก',
      delete: 'ลบ',
      deleteCancel: 'ยกเลิก',
      deleteContent: 'PDF นี้ไม่สามารถกู้คืนได้เมื่อลบ คุณแน่ใจหรือไม่?',
      deleteOk: 'ลบ',
      deleteSuccess: 'ถูกลบออก',
      deleteTitle: 'ยืนยันการลบ',
      expand: 'ทรุด',
      historyTitle: 'ประวัติศาสตร์',
      listError: 'ไม่สามารถโหลดรายการการอ่านได้ โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
      loading: 'กำลังโหลด ...',
      noDataDesc: 'ยังไม่มีประวัติ',
      noMore: 'ไม่มีเนื้อหาเพิ่มเติม',
      placeholder: 'ถามอะไรเกี่ยวกับ PDF นี้',
      summaryTitle: 'คุณอาจสนใจคำถามเหล่านี้:',
    },
    collectionEmpty: 'คอลเลกชันของคุณว่างเปล่า',
    collectionTab: 'หมายเหตุ',
    dataLoading: 'กำลังโหลด ...',
    dialogContent: 'แน่ใจหรือว่าต้องการลบสิ่งนี้?',
    dialogTitle: 'โปรดยืนยัน',
    download: {
      both: 'สองภาษา',
      btn: 'บันทึก',
      cancel: 'การปิดหน้าต่างนี้จะยกเลิกการดาวน์โหลด PDF แน่ใจหรือว่าต้องการยกเลิก?',
      desc: 'บันทึกไปยังอุปกรณ์: ดาวน์โหลดการแปลเป็นรูปภาพ; บันทึกและพิมพ์: ดาวน์โหลดการแปลในรูปแบบดั้งเดิมพร้อมการสนับสนุนสำเนา',
      download: 'การดาวน์โหลด',
      downloadMsg1: 'ความคืบหน้าการแปล PDF:',
      downloadMsg2: 'เวลาที่เหลืออยู่โดยประมาณ:',
      downloadSucc: 'PDF พร้อมแล้ว! คลิกเพื่อบันทึก',
      downloadTip: 'ดาวน์โหลด PDF อย่าปิดหน้าต่างนี้เพื่อหลีกเลี่ยงข้อผิดพลาดในการดาวน์โหลด',
      error: 'ไม่สามารถบันทึกได้ ลองพิมพ์แทน',
      fileName: 'ชื่อไฟล์:',
      fileType: 'ประเภทไฟล์:',
      loading: 'ประหยัด...',
      loading2: 'กำลังโหลด ...',
      minute: 'นาที...',
      msg1: 'การแปลบางอย่างในเอกสารนี้ยาวกว่าข้อความต้นฉบับและอาจทับซ้อนกันในไฟล์ที่ดาวน์โหลด เราขอแนะนำให้อ่านบนหน้าเว็บ',
      msg2: '1. การแปลยังไม่สมบูรณ์ โปรดดาวน์โหลดหลังจากการแปลเสร็จสิ้น',
      msg3: '2. การแปลบางอย่างยาวเกินไป อ่านบนหน้าเว็บเพื่อหลีกเลี่ยงการทับซ้อนข้อความ',
      msg4: 'งานการแปลกำลังดำเนินการอยู่ โปรดลองอีกครั้งหลังจากเสร็จสิ้น',
      progress: 'แปล PDF ความคืบหน้า: {{ความคืบหน้า}} เวลาที่เหลืออยู่โดยประมาณ: {{นาที}} นาที ...',
      save: 'บันทึกลงในอุปกรณ์',
      savePrint: 'บันทึกและพิมพ์',
      success: 'ที่ดาวน์โหลด',
      trans: 'การแปลเท่านั้น',
      transContinue: 'แปลต่อไป',
    },
    downloadBtn: 'การดาวน์โหลด',
    dragTipModal: {
      black: 'ช่องว่าง',
      leftKey: 'ปุ่มซ้าย',
      ok: 'เข้าใจแล้ว',
      press: 'กด',
      tips: 'เพื่อลากและดู',
    },
    entry: 'PDFS',
    fileErrMsg: 'การอ่านไฟล์ล้มเหลว โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    fileMsg: 'ขนาดไฟล์ปัจจุบัน:',
    fileMsg2: 'โปรดอัปโหลดไฟล์ที่เล็กกว่า 300MB',
    freeBannerBtn: 'อัพเกรด',
    freeBannerTips: 'ถึงขีด จำกัด การแปล PDF ฟรี',
    guide: {
      placeholder: 'วางลิงค์ PDF ที่นี่',
      start: 'เริ่มแปล',
      text1: 'การอ่านสองภาษา',
      text2:
        'อ่าน bilingually เพื่อเปรียบเทียบข้อความต้นฉบับและการแปลเคียงข้างกันปรับปรุงประสิทธิภาพของคุณ',
      text3: 'แชทกับ PDF ของคุณ',
      text4: 'การวิเคราะห์และการสรุป AI ถามคำถามเกี่ยวกับ PDF ของคุณและรับคำตอบทันที',
      text5: 'ถูกต้องและมีประสิทธิภาพ',
      text6: 'การแปล PDF ที่ขับเคลื่อนด้วย AI เพื่อความแม่นยำและประสิทธิภาพที่มากขึ้น',
      title1: 'การแปลสองภาษา',
      title2: 'แชทกับ PDF ของคุณ',
      toast: 'กรุณากรอกลิงค์ PDF ออนไลน์ที่ถูกต้องลงท้ายด้วย. pdf',
    },
    hasTransTask: 'งานแปลกำลังดำเนินการอยู่ โปรดรอ.',
    hoverTrans: 'วรรคใหม่',
    initial: 'แปล PDF',
    installText: 'โซลูชันแบบครบวงจรของคุณสำหรับการแปลในชีวิตประจำวัน',
    installText2: 'กรุณาติดตั้งส่วนขยายก่อน',
    installTips: 'ติดตั้งส่วนขยายสำหรับการแปล PDF เพิ่มเติมและการแปลเว็บไซต์ที่ราบรื่นขึ้น:',
    kw: 'วัตถุดิบหลัก',
    link: 'การเชื่อมโยง',
    listError: 'ไม่สามารถโหลด PDF ได้ โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    memoTotalCount: 'รวม 1 รายการ',
    new: 'ไฟล์ใหม่',
    noId: 'ไม่พบรหัสไฟล์',
    notPdf: 'ไฟล์ PDF เท่านั้น',
    okBtn: 'ลบ',
    okBtn2: 'เข้าใจแล้ว',
    original: 'ต้นฉบับ',
    parallel: 'ขนาน',
    parseErrDialogContent:
      'ลิงค์ PDF นี้ไม่สามารถแปลได้โดยตรง โปรดดาวน์โหลด PDF และอัปโหลดเพื่อการแปล',
    parseErrTips: 'ไม่สามารถแยกวิเคราะห์ไฟล์ได้',
    parseFileToast: 'ไม่สามารถแยกวิเคราะห์ไฟล์ได้ โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    pdfLoading: 'การแยกวิเคราะห์ ...',
    searchPlaceholder: 'ค้นหา',
    selectTrans: 'เลือกข้อความเพื่อแปล',
    shareBtn: 'แบ่งปัน',
    shareBtnText1: 'สร้างลิงค์หุ้น',
    shareBtnText2: 'อัปเดตเนื้อหาที่ใช้ร่วมกัน',
    shareModal: {
      cancel: 'ยกเลิก',
      copy: 'สำเนา',
      copySucc: 'ลิงค์คัดลอก',
      custom: 'ปรับแต่ง:',
      errMsg: 'เนื้อหาที่เลือกยังไม่ได้รับการแปลอย่างสมบูรณ์ โปรดแปลก่อนแบ่งปัน',
      gen: 'แบ่งปัน',
      modify: 'แก้ไข',
      notSupport: 'ภาษานี้ไม่ได้รับการสนับสนุนในปัจจุบัน',
      page: 'หน้า',
      pageNuErr: 'กรุณากรอกหมายเลขหน้าเว็บที่ถูกต้อง',
      range: 'ขอบเขต:',
      remain: 'ที่เหลืออยู่',
      remain1: 'เวลาโดยประมาณทั้งหมด:',
      search: 'ค้นหา',
      settings: 'แชร์การตั้งค่า:',
      shareSetting: 'แชร์การตั้งค่า',
      shareText: 'แบ่งปัน',
      shareTips: 'แบ่งปันลิงค์ PDF ที่แปลกับเพื่อนของคุณ:',
      sourceLang: 'จาก:',
      target: 'ถึง:',
      text1: 'แชร์การตั้งค่า',
      text2: 'สร้างลิงค์หุ้น',
      totalPage: 'รวม 1 หน้า',
      trans: 'แปล',
      translateTips: 'เคล็ดลับ: หากการแปลใช้เวลาสักครู่คุณสามารถปิดหน้าต่างนี้และแบ่งปันในภายหลัง',
      translating: 'แปล PDF ...',
      update: 'อัปเดตลิงค์แชร์',
    },
    shareMsg1: 'แชร์ลิงก์ที่สร้างขึ้น',
    shareMsg2: 'อัปเดตเนื้อหาที่แชร์',
    shareMsg3: 'ไม่สามารถสร้างลิงค์แบ่งปันได้ โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    shareMsg4: 'ไม่สามารถอัปเดตเนื้อหาที่แชร์ได้ โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    shareTips: 'การแปล PDF ของคุณพร้อมแล้ว! แบ่งปันกับเพื่อนของคุณ',
    start: 'เริ่มทดลองใช้ฟรี',
    thumbnail: 'สารบัญ',
    toast1: 'กำลังโหลด PDF โปรดลองอีกครั้งในภายหลัง',
    toast2: 'เนื้อหา PDF มีขนาดใหญ่เกินไป กล่องโต้ตอบไม่ได้รับการสนับสนุนในขณะนี้',
    toast3: 'ดาวน์โหลด โปรดลองอีกครั้งหลังจากการดาวน์โหลดเสร็จสิ้น',
    toolbar: { Adjust: 'ปรับ', autoFit: 'พอดีกับอัตโนมัติ' },
    trans: 'การแปล',
    transSucc: 'การแปลประสบความสำเร็จ!',
    unLoginToast: 'โปรดเข้าสู่ระบบเพื่อใช้คุณสมบัตินี้',
    uploadBtn: 'อัพโหลด',
    uploadErr: 'การอัปโหลดไฟล์ล้มเหลว โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    uploadErrSignUrl: 'ไม่ได้รับ URL อัปโหลด โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    uploadMsg1: 'ลากและวางไฟล์ของคุณที่นี่',
    uploadMsg2: 'ประเภทไฟล์ที่รองรับ: PDF |  ขนาดไฟล์สูงสุด: 300MB',
    uploadMsg3: 'คลิกเพื่อเลือกหรือลากและวางไฟล์ที่นี่',
    uploading: 'การอัพโหลด',
    uploadingMsg: 'อัปโหลด โปรดรอ.',
    uploadingMsg1: 'ไฟล์กำลังอัปโหลด โปรดลองอีกครั้งในภายหลัง',
    uploadingMsg2: 'ขณะนี้ไฟล์กำลังถูกแปลง โปรดลองอีกครั้งในภายหลัง',
    uploadingMsg3: 'คำขอความคืบหน้าการแปลงล้มเหลว โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    uploadingMsg4: 'noam ไม่สามารถเข้าถึงไฟล์ในพื้นที่ได้ โปรดอัปโหลด PDF ด้วยตนเองเพื่อแปล',
    uploadingMsg5: 'ไม่สามารถดึง URL ไฟล์ได้ โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    video: 'วิดีโอ',
    vipBannerBtn: 'อัพเกรด',
    vipBannerTips: 'คุณมาถึงขีด จำกัด การแปล PDF ของคุณสำหรับเดือนนี้',
    webTrans: 'การอ้างอิงข้ามเต็มรูปแบบ',
  },
  pricing: {
    FAQ: 'คำถามที่พบบ่อย',
    FQAObj: {
      a1: 'ใช่ Noam เสนอแผนฟรีที่คุณสามารถใช้ได้ทันที',
      a2: 'เราเสนอแผนการสมาชิกสามแผน: Pro, Pro+และ Enterprise คุณสามารถเลือกจ่ายรายเดือนหรือทุกปี การเรียกเก็บเงินประจำปีให้การออมที่สำคัญ',
      a3: 'คุณสมบัติทั้งหมดมีอยู่ในแผนทั้งสอง ความแตกต่างที่สำคัญคือค่าใช้จ่าย: การสมัครสมาชิกรายปีมีค่าใช้จ่ายโดยรวมน้อยลง การสมัครสมาชิกรายเดือนจะถูกเรียกเก็บเงินในแต่ละเดือนในขณะที่แผนรายปีจะถูกเรียกเก็บเงินปีละครั้ง',
      a4: 'คุณสามารถยกเลิกการสมัครสมาชิกได้ตลอดเวลาในการตั้งค่าบัญชีของคุณ',
      q1: 'มีแผนฟรีหรือไม่?',
      q2: 'มีแผนราคาและตัวเลือกการชำระเงินใดบ้าง',
      q3: 'การสมัครสมาชิกรายเดือนกับทุกปีแตกต่างกันอย่างไร',
      q4: 'ฉันจะยกเลิกการสมัครสมาชิกได้อย่างไร?',
    },
    around: 'รอบๆ',
    billedMonthly: 'เรียกเก็บเงินรายเดือน',
    billedYearly: 'เรียกเก็บเงินทุกปี',
    day: 'วัน',
    desc: 'เปรียบเทียบแผนและเลือกสิ่งที่ดีที่สุด',
    detailedCompare: 'เปรียบเทียบแผน',
    discount: 'ลด 20%',
    enterprise: {
      benefit1: 'การสนับสนุนลูกค้าลำดับความสำคัญ',
      benefit2: 'ผู้ใช้หลายคน',
      benefit3: 'โซลูชั่นที่ปรับแต่ง',
      benefit5: 'ผู้จัดการบัญชีเฉพาะ',
      btn: 'ติดต่อเรา',
      recommendText: 'แผนกำหนดเอง （≥3 人）',
      talkToUs: 'ติดต่อกลับ',
    },
    free: {
      benefit1: 'การแปลทันที 100 ครั้ง/วัน',
      benefit2: 'การแปลและสรุปเว็บไซต์',
      benefit3: '30 การแปลภาพ',
      benefit4: 'การแปลวิดีโอและสรุป',
      benefit5: '10 PDF แปล',
      benefit6: '5,000 โทเค็น',
      btn: 'ลองฟรี',
      recommendText: 'ทดลองใช้ฟรี',
    },
    imageTranslation: 'การแปลภาพ',
    month: 'เดือน',
    monthly: 'รายเดือน',
    pageTitle: 'การกำหนดราคา',
    pdf: { chat: 'ข้อความค้นหา PDF', maxPage: 'สูงสุด หน้าต่อ pdf', translation: 'การแปล PDF' },
    preMonth: 'ต่อเดือน',
    pro: {
      benefit1: 'การสนับสนุนลูกค้าลำดับความสำคัญ',
      benefit2: '1,000,000 โทเค็น/เดือน',
      benefit3: 'การแปลและสรุปเว็บไซต์',
      benefit4: 'การแปลภาพ 200 ภาพ',
      benefit5: 'การแปลวิดีโอและสรุป',
      benefit6: 'การแปล PDF 200 ครั้ง',
      btn: 'เริ่มต้นใช้งาน',
      recommendText: 'ยอดนิยมมากที่สุด',
    },
    proPlus: {
      benefit1: 'การสนับสนุนลูกค้าลำดับความสำคัญ',
      benefit2: '3,000,000 โทเค็น/เดือน',
      benefit3: 'การแปลและสรุปเว็บไซต์',
      benefit4: 'การแปลภาพ 500 ภาพ',
      benefit5: 'การแปลวิดีโอและสรุป',
      benefit6: 'การแปล 500 PDF',
      recommendText: 'คุ้มค่า',
    },
    video: { summary: 'สรุปวิดีโอ', translation: 'การแปลวิดีโอ' },
    web: {
      contrastiveTranslation: 'การแปลสองภาษา',
      dictionaryTranslation: 'การแปลการเลือก',
      hoverTranslation: 'การแปลโฮเวอร์',
      instantTranslation: 'การแปลทันที',
      summary: 'สรุปหน้าเว็บ',
    },
    yearly: 'ทุกปี',
  },
  privacy: {
    block1:
      'noam ("noam," "เรา," "ของเรา," หรือ "เรา") เคารพความเป็นส่วนตัวของคุณและมุ่งมั่นที่จะปกป้องข้อมูลใด ๆ ที่เราได้รับจากคุณหรือเกี่ยวกับคุณ นโยบายความเป็นส่วนตัวนี้อธิบายแนวทางปฏิบัติของเราเกี่ยวกับการรวบรวมหรือการใช้ข้อมูลส่วนบุคคลจากการใช้เว็บไซต์แอปพลิเคชันและบริการของเรา (โดยรวม "บริการ") นโยบายความเป็นส่วนตัวนี้ไม่ได้ใช้กับเนื้อหาที่เราจัดการในนามของลูกค้าผลิตภัณฑ์ธุรกิจของเราเช่น API ของเรา การใช้ข้อมูลนี้ขึ้นอยู่กับข้อตกลงลูกค้าของเราซึ่งครอบคลุมการเข้าถึงและการใช้ผลิตภัณฑ์เหล่านี้',
    block10:
      'เราใช้มาตรการทางเทคนิคการบริหารและองค์กรที่สมเหตุสมผลในเชิงพาณิชย์เพื่อปกป้องข้อมูลส่วนบุคคลออนไลน์และออฟไลน์จากการสูญเสียการใช้งานในทางที่ผิดและการเข้าถึงการเปิดเผยการเปลี่ยนแปลงหรือการกระทำที่ไม่เหมาะสมโดยไม่ได้รับอนุญาต อย่างไรก็ตามไม่มีการส่งผ่านอินเทอร์เน็ตหรืออีเมลที่สามารถรับประกันความปลอดภัยหรือความถูกต้องได้อย่างสมบูรณ์ โดยเฉพาะอย่างยิ่งอีเมลที่ส่งถึงเราหรือจากเราอาจไม่ปลอดภัย ดังนั้นคุณควรระมัดระวังเป็นพิเศษเมื่อตัดสินใจว่าจะส่งข้อมูลใดให้เราผ่านบริการหรืออีเมล นอกจากนี้เราจะไม่รับผิดชอบต่อสิ่งกีดขวางการตั้งค่าความเป็นส่วนตัวหรือมาตรการรักษาความปลอดภัยในการตั้งค่าบริการหรือการตั้งค่าความปลอดภัยของเว็บไซต์บุคคลที่สามหรือมาตรการรักษาความปลอดภัย เราจะเก็บข้อมูลส่วนบุคคลของคุณไว้นานเท่าที่จำเป็นสำหรับเราในการให้บริการหรือเพื่อวัตถุประสงค์ทางธุรกิจที่ถูกกฎหมายอื่น ๆ เช่นการแก้ไขข้อพิพาทเหตุผลด้านความปลอดภัยและความปลอดภัยหรือปฏิบัติตามภาระหน้าที่ทางกฎหมายของเรา ระยะเวลาที่เราเก็บรักษาข้อมูลส่วนบุคคลจะขึ้นอยู่กับปัจจัยหลายอย่างเช่นจำนวนธรรมชาติความอ่อนไหวของข้อมูลความเสี่ยงที่อาจเกิดขึ้นจากการใช้หรือการเปิดเผยโดยไม่ได้รับอนุญาตวัตถุประสงค์ที่เราประมวลผลข้อมูลและการพิจารณาที่มีผลผูกพันตามกฎหมายอื่น ๆ',
    block11:
      'เราอาจอัปเดตนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว เมื่อเราทำเช่นนั้นเราจะโพสต์เวอร์ชันที่อัปเดตในหน้านี้เว้นแต่ว่ากฎหมายที่ใช้บังคับเป็นอย่างอื่น',
    block12:
      'หากคุณมีคำถามหรือข้อสงสัยที่ยังไม่ได้ตอบเกี่ยวกับนโยบายความเป็นส่วนตัวนี้โปรดติดต่อฝ่ายบริการลูกค้าของเรา อีเมล:',
    block2: 'เรารวบรวมข้อมูลส่วนบุคคลต่อไปนี้ ("ข้อมูลส่วนบุคคล") ที่เกี่ยวข้องกับคุณ:',
    block3:
      'ข้อมูลที่คุณได้รับ: เมื่อคุณสร้างบัญชีเพื่อใช้บริการของเราหรือสื่อสารกับเราเราจะรวบรวมข้อมูลส่วนบุคคลดังนี้:',
    block4:
      'ข้อมูลส่วนบุคคลที่ได้รับโดยอัตโนมัติจากการใช้บริการของคุณ: เมื่อคุณเข้าถึงใช้หรือโต้ตอบกับบริการเราจะได้รับข้อมูลต่อไปนี้เกี่ยวกับการเข้าถึงการใช้หรือการโต้ตอบ ("ข้อมูลทางเทคนิค"):',
    block5: 'เราอาจใช้ข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ต่อไปนี้:',
    block6:
      'ข้อมูลสรุปหรือข้อมูลที่ไม่ระบุตัวตน: เราอาจรวมหรือยกเลิกการระบุข้อมูลส่วนบุคคลเพื่อป้องกันการใช้ซ้ำเพื่อวัตถุประสงค์ในการระบุตัวตนและใช้ข้อมูลดังกล่าวเพื่อวิเคราะห์ประสิทธิภาพของบริการของเราปรับปรุงและเพิ่มคุณสมบัติให้กับบริการของเราดำเนินการวิจัยและเพื่อวัตถุประสงค์ที่คล้ายกัน นอกจากนี้เราอาจวิเคราะห์พฤติกรรมและลักษณะทั่วไปของผู้ใช้บริการของเราและแบ่งปันข้อมูลที่รวมกับบุคคลที่สามเผยแพร่ข้อมูลที่รวมดังกล่าวหรือทำให้มันพร้อมใช้งานโดยทั่วไป เราอาจรวบรวมข้อมูลรวมผ่านบริการผ่านคุกกี้และด้วยวิธีการอื่น ๆ ที่อธิบายไว้ในนโยบายความเป็นส่วนตัวนี้ เราจะเก็บรักษาและใช้ข้อมูลที่ไม่ระบุตัวตนในรูปแบบที่ไม่ระบุชื่อหรือไม่ระบุตัวตนและเราจะไม่พยายามระบุข้อมูลดังกล่าวอีกครั้งเว้นแต่จะมีกฎหมาย',
    block7:
      'ในบางกรณีเราอาจให้ข้อมูลส่วนบุคคลของคุณแก่บุคคลที่สามโดยไม่ต้องแจ้งให้คุณทราบเพิ่มเติมเว้นแต่ว่ากฎหมายกำหนด:',
    block8:
      'ขึ้นอยู่กับที่ตั้งทางภูมิศาสตร์ของคุณบุคคลในเขตเศรษฐกิจยุโรปสหราชอาณาจักรและทั่วโลกอาจมีสิทธิตามกฎหมายบางประการเกี่ยวกับข้อมูลส่วนบุคคลของพวกเขา ตัวอย่างเช่นคุณอาจมีสิทธิ์ที่จะ:',
    block9:
      'บริการอาจมีลิงก์ไปยังเว็บไซต์อื่น ๆ ที่ไม่ได้ดำเนินการหรือควบคุมโดย NOAM รวมถึงบริการโซเชียลมีเดีย ("เว็บไซต์บุคคลที่สาม") ข้อมูลที่คุณแบ่งปันกับเว็บไซต์บุคคลที่สามจะถูกควบคุมโดยนโยบายความเป็นส่วนตัวเฉพาะและข้อกำหนดในการให้บริการของเว็บไซต์บุคคลที่สามไม่ใช่นโยบายความเป็นส่วนตัวนี้ เราให้ลิงก์เหล่านี้เพื่อความสะดวกและไม่ได้หมายความถึงการรับรองหรือตรวจสอบเว็บไซต์เหล่านี้ กรุณาติดต่อเว็บไซต์บุคคลที่สามโดยตรงสำหรับข้อมูลเกี่ยวกับนโยบายและข้อกำหนดความเป็นส่วนตัวของพวกเขา',
    subBlock1:
      'ข้อมูลบัญชี: เมื่อคุณสร้างบัญชีบนแพลตฟอร์มของเราเราจะรวบรวมข้อมูลที่เกี่ยวข้องกับบัญชีของคุณรวมถึงชื่อของคุณข้อมูลติดต่อข้อมูลรับรองบัญชีข้อมูลบัตรชำระเงินและประวัติการทำธุรกรรม ("ข้อมูลบัญชี")',
    subBlock10: 'การจัดหาการจัดการการบำรุงรักษาและ/หรือการวิเคราะห์บริการ',
    subBlock11: 'สื่อสารกับคุณ;',
    subBlock12: 'การพัฒนาผลิตภัณฑ์และบริการใหม่',
    subBlock13:
      'การป้องกันการฉ้อโกงกิจกรรมทางอาญาหรือการใช้บริการของเราในทางที่ผิดและปกป้องความปลอดภัยของระบบไอทีสถาปัตยกรรมและเครือข่ายของเรา',
    subBlock14: 'ดำเนินการโอนธุรกิจ',
    subBlock15:
      'ปฏิบัติตามภาระผูกพันทางกฎหมายและการดำเนินคดีทางกฎหมายปกป้องสิทธิความเป็นส่วนตัวความปลอดภัยหรือทรัพย์สินของเรารวมถึง บริษัท ในเครือของเราคุณหรือบุคคลที่สามอื่น ๆ ของเรา',
    subBlock16:
      'ซัพพลายเออร์และผู้ให้บริการ: เพื่อช่วยเหลือเราในการตอบสนองความต้องการด้านการดำเนินงานทางธุรกิจและดำเนินการบริการและฟังก์ชั่นบางอย่างเราอาจให้ข้อมูลส่วนบุคคลแก่ซัพพลายเออร์และผู้ให้บริการรวมถึงผู้ให้บริการโฮสต์ผู้ให้บริการคลาวด์ผู้ให้บริการและผู้ให้บริการเทคโนโลยีสารสนเทศอื่น ๆ',
    subBlock17:
      'การถ่ายโอนธุรกิจ: หากเรามีส่วนร่วมในการทำธุรกรรมเชิงกลยุทธ์การปรับโครงสร้างองค์กรการล้มละลายการซื้อกิจการล้มละลายหรือการเปลี่ยนบริการไปยังผู้ให้บริการรายอื่น (โดยรวม "การทำธุรกรรม") ข้อมูลส่วนบุคคลของคุณและข้อมูลอื่น ๆ อาจถูกแบ่งปันกับการทำธุรกรรม',
    subBlock18:
      'ข้อกำหนดทางกฎหมาย: เราอาจแบ่งปันข้อมูลส่วนบุคคลของคุณกับหน่วยงานของรัฐเพื่อนร่วมงานในอุตสาหกรรมหรือบุคคลที่สามอื่น ๆ รวมถึงข้อมูลการโต้ตอบของคุณกับบริการของเรา (1) หากจำเป็นตามกฎหมายหรือหากเราเชื่อว่าการกระทำดังกล่าวจำเป็นต้องปฏิบัติตามภาระผูกพันทางกฎหมาย (2) เพื่อปกป้องและปกป้องสิทธิหรือทรัพย์สินของเรา (3) หากเราพิจารณาเพียงฝ่ายเดียวว่ามีการละเมิดข้อกำหนดนโยบายหรือกฎหมายของเรา (4) ตรวจจับหรือป้องกันการฉ้อโกงหรือกิจกรรมที่ผิดกฎหมายอื่น ๆ (5) เพื่อปกป้องผลิตภัณฑ์พนักงานหรือผู้ใช้หรือความปลอดภัยสาธารณะความปลอดภัยความซื่อสัตย์ หรือ (vi) เพื่อป้องกันความรับผิดทางกฎหมาย',
    subBlock19: 'เข้าถึงข้อมูลส่วนบุคคลของคุณและข้อมูลเกี่ยวกับวิธีการประมวลผล',
    subBlock2:
      'เนื้อหาของผู้ใช้: เมื่อคุณใช้บริการของเราเราจะรวบรวมข้อมูลส่วนบุคคลจากอินพุตของคุณการอัปโหลดไฟล์หรือข้อเสนอแนะที่มีให้กับเรา ("เนื้อหา")',
    subBlock20: 'ขอการลบข้อมูลส่วนบุคคลของคุณจากบันทึกของเรา',
    subBlock21: 'แก้ไขหรืออัปเดตข้อมูลส่วนบุคคลของคุณ',
    subBlock22: 'ถ่ายโอนข้อมูลส่วนบุคคลของคุณไปยังบุคคลที่สาม (การพกพาข้อมูล)',
    subBlock23: 'จำกัด วิธีที่เราประมวลผลข้อมูลส่วนบุคคลของคุณ',
    subBlock24:
      'ถอนความยินยอมของคุณ - ที่ที่เราพึ่งพาความยินยอมเป็นพื้นฐานทางกฎหมายสำหรับการประมวลผลคุณสามารถถอนความยินยอมของคุณได้ตลอดเวลา',
    subBlock25: 'คัดค้านวิธีที่เราประมวลผลข้อมูลส่วนบุคคลของคุณ',
    subBlock26: 'การปรับปรุงบริการของเราและดำเนินการวิจัย',
    subBlock3:
      'ข้อมูลการสื่อสาร: หากคุณส่งข้อความถึงเราเราจะรวบรวมชื่อข้อมูลติดต่อและเนื้อหาของข้อความของคุณ ("ข้อมูลการสื่อสาร")',
    subBlock4:
      'ข้อมูลโซเชียลมีเดีย: เรามีหน้าบนเว็บไซต์โซเชียลมีเดียเช่น Instagram, Facebook, Medium, Twitter, YouTube และ LinkedIn เมื่อคุณโต้ตอบกับหน้าโซเชียลมีเดียของเราเราจะรวบรวมข้อมูลส่วนบุคคลที่คุณเลือกให้กับเราเช่นรายละเอียดการติดต่อของคุณ ("ข้อมูลโซเชียล") นอกจากนี้ บริษัท ที่โฮสต์หน้าโซเชียลมีเดียของเราอาจให้ข้อมูลและการวิเคราะห์รวมเกี่ยวกับกิจกรรมโซเชียลมีเดียของเรา',
    subBlock5:
      'ข้อมูลบันทึก: ข้อมูลที่ส่งโดยเบราว์เซอร์ของคุณโดยอัตโนมัติเมื่อใช้บริการของเรา ข้อมูลบันทึกรวมที่อยู่อินเทอร์เน็ตโปรโตคอล (IP) ของคุณประเภทเบราว์เซอร์และการตั้งค่าวันที่และเวลาตามคำขอของคุณและวิธีที่คุณโต้ตอบกับเว็บไซต์ของเรา',
    subBlock6:
      'ข้อมูลการใช้งาน: เราอาจรวบรวมข้อมูลเกี่ยวกับการใช้บริการของคุณโดยอัตโนมัติเช่นประเภทของเนื้อหาที่คุณดูหรือโต้ตอบกับคุณสมบัติที่คุณใช้การกระทำที่คุณดำเนินการรวมถึงเขตเวลาประเทศวันที่และเวลาในการเข้าถึงตัวแทนผู้ใช้และเวอร์ชันคอมพิวเตอร์หรืออุปกรณ์พกพาและการเชื่อมต่อคอมพิวเตอร์ของคุณ',
    subBlock7:
      'ข้อมูลอุปกรณ์: ซึ่งรวมถึงชื่ออุปกรณ์ระบบปฏิบัติการตัวระบุอุปกรณ์และเบราว์เซอร์ที่คุณใช้ ข้อมูลที่รวบรวมอาจขึ้นอยู่กับประเภทของอุปกรณ์ที่คุณใช้และการตั้งค่า',
    subBlock8:
      'คุกกี้: เราใช้คุกกี้ในการใช้งานและจัดการบริการของเราและปรับปรุงประสบการณ์ของคุณ "คุกกี้" คือข้อมูลที่ส่งโดยเว็บไซต์ที่คุณเยี่ยมชมเบราว์เซอร์ของคุณ คุณสามารถตั้งค่าเบราว์เซอร์ให้ยอมรับคุกกี้ทั้งหมดปฏิเสธคุกกี้ทั้งหมดหรือแจ้งให้คุณทราบเมื่อมีการจัดเตรียมคุกกี้เพื่อให้คุณสามารถตัดสินใจได้ว่าจะยอมรับมันในแต่ละครั้งหรือไม่ อย่างไรก็ตามการปฏิเสธคุกกี้อาจป้องกันไม่ให้คุณใช้หรือส่งผลเสียต่อการแสดงผลหรือการทำงานของพื้นที่หรือคุณสมบัติบางอย่างของเว็บไซต์ สำหรับข้อมูลเพิ่มเติมเกี่ยวกับคุกกี้กรุณาเยี่ยมชมทุกอย่างเกี่ยวกับคุกกี้',
    subBlock9:
      'Analytics: เราอาจใช้ผลิตภัณฑ์วิเคราะห์ออนไลน์ที่หลากหลายที่ใช้คุกกี้เพื่อช่วยให้เราวิเคราะห์ว่าผู้ใช้ใช้บริการของเราและปรับปรุงประสบการณ์ของคุณเมื่อใช้บริการ',
    subTitle1: 'ข้อมูลส่วนบุคคลที่เรารวบรวม',
    subTitle2: 'เราใช้ข้อมูลส่วนบุคคลอย่างไร',
    subTitle3: 'การเปิดเผยข้อมูลส่วนบุคคล',
    subTitle4: 'สิทธิของคุณ',
    subTitle5: 'ลิงก์ไปยังเว็บไซต์อื่น ๆ',
    subTitle6: 'ความปลอดภัยและการเก็บรักษาข้อมูล',
    subTitle7: 'การปรับเปลี่ยนนโยบายความเป็นส่วนตัว',
    subTitle8: 'วิธีติดต่อเรา',
    title: 'นโยบายความเป็นส่วนตัว',
    updateTime: 'อัปเดต: 15 มีนาคม 2567',
  },
  privacyCollectionPanel: {
    acceptBtn: 'ยอมรับทั้งหมด',
    text: 'เพื่อปรับปรุงประสบการณ์ของคุณเราใช้คุกกี้เพื่อปรับแต่งเนื้อหาและบริการ',
    title: 'เว็บไซต์นี้ใช้คุกกี้',
  },
  slogen: 'ผู้ช่วย AI ที่ง่ายที่สุด',
  stripe: {
    contact: 'ติดต่อเราที่ contact@noam.tools พร้อมคำถามใด ๆ !',
    fail: {
      btn: 'ลองอีกครั้ง',
      text1: 'เราไม่สามารถดำเนินการชำระเงินของคุณได้',
      text2: 'ตรวจสอบการเชื่อมต่อของคุณและลองอีกครั้ง',
      title: 'การชำระเงินล้มเหลว',
    },
    succ: {
      btn: 'ไปกันเถอะ',
      text1: 'ยินดีต้อนรับสู่ Noam',
      text2: 'เริ่มต้นกันเถอะ!',
      title: 'ยินดีด้วย',
    },
  },
  terms: {
    block1: 'ขอบคุณที่ใช้ noam!',
    block10:
      '(a) ค่าธรรมเนียมและการเรียกเก็บเงิน คุณจะจ่ายค่าธรรมเนียมทั้งหมด ("ค่าธรรมเนียม") ตามราคาและข้อกำหนดในหน้าราคาที่เกี่ยวข้องหรือตามที่ตกลงกันไว้เป็นลายลักษณ์อักษรระหว่างเรา เราขอสงวนสิทธิ์ในการแก้ไขข้อผิดพลาดการกำหนดราคาหรือข้อผิดพลาดแม้ว่าเราจะออกใบแจ้งหนี้หรือได้รับการชำระเงิน คุณจะให้ข้อมูลการเรียกเก็บเงินที่สมบูรณ์และถูกต้องรวมถึงวิธีการชำระเงินที่ถูกต้องและได้รับอนุญาต เราจะเรียกเก็บเงินวิธีการชำระเงินของคุณเป็นระยะตามที่ตกลงกันไว้ แต่เราอาจเปลี่ยนวันที่เรียกเก็บเงินได้อย่างสมเหตุสมผล คุณอนุญาตให้ NOAM, บริษัท ในเครือและโปรเซสเซอร์การชำระเงินของบุคคลที่สามเพื่อเรียกเก็บเงินวิธีการชำระเงินของคุณ หากการชำระเงินของคุณล้มเหลวเราจะแจ้งให้คุณทราบเป็นลายลักษณ์อักษรและอาจระงับการเข้าถึงบริการจนกว่าจะได้รับการชำระเงิน ยกเว้นตามที่ระบุไว้เป็นอย่างอื่นในข้อตกลงนี้การชำระเงินจะไม่คืนเงิน',
    block11:
      '(b) ภาษี ค่าธรรมเนียมจะไม่รวมภาษีของรัฐบาลกลางรัฐท้องถิ่นและต่างประเทศหน้าที่และการประเมินที่คล้ายกัน ("ภาษี") คุณต้องรับผิดชอบภาษีทั้งหมดที่เกี่ยวข้องกับการซื้อของคุณไม่รวมภาษีตามรายได้สุทธิของเราซึ่งเราจะออกใบแจ้งหนี้คุณ คุณตกลงที่จะจ่ายภาษีดังกล่าวทันทีและให้คำแถลงความเป็นส่วนตัวที่ถูกต้องตามกฎหมายและได้รับความยินยอมที่จำเป็นสำหรับการจัดการข้อมูลดังกล่าวและคุณรับประกันกับเราว่าคุณจัดการข้อมูลดังกล่าวตามกฎหมายที่เกี่ยวข้อง',
    block12:
      '(c) การเปลี่ยนแปลงราคา เราอาจเปลี่ยนราคาของเราโดยแจ้งให้คุณทราบผ่านบัญชีของคุณและ/หรือเว็บไซต์ของเรา การเพิ่มขึ้นของราคาจะมีผลทันทีเมื่อโพสต์ การเปลี่ยนแปลงราคาใด ๆ จะนำไปใช้กับค่าธรรมเนียมสำหรับบัญชีของคุณหลังจากวันที่มีการเปลี่ยนแปลง',
    block13:
      '(d) ข้อพิพาทและการชำระเงินเกินกำหนด หากคุณต้องการโต้แย้งค่าธรรมเนียมหรือภาษีใด ๆ โปรดติดต่อ contact@noam.tools ภายในสามสิบ (30) วันนับจากวันที่ออกใบแจ้งหนี้',
    block14:
      '(e) การใช้งานฟรี คุณไม่สามารถสร้างหลายบัญชีเพื่อรับเครดิตฟรี หากเราพิจารณาว่าคุณไม่ได้ใช้เครดิตฟรีโดยสุจริตเราอาจเรียกเก็บค่าธรรมเนียมมาตรฐานของคุณหรือหยุดให้การเข้าถึงบริการ',
    block15:
      '(a) การรักษาความลับ คุณอาจเข้าถึงข้อมูลที่เป็นความลับของ NOAM คุณสามารถใช้ข้อมูลที่เป็นความลับตามที่ได้รับอนุญาตภายใต้ข้อกำหนดเหล่านี้เพื่อวัตถุประสงค์ในการใช้บริการ คุณไม่สามารถเปิดเผยข้อมูลที่เป็นความลับให้กับบุคคลที่สามและคุณจะปกป้องข้อมูลที่เป็นความลับในลักษณะที่ไม่ได้รับการปกป้องน้อยกว่าที่คุณปกป้องข้อมูลที่เป็นความลับที่คล้ายกันของคุณอย่างน้อยก็ด้วยความระมัดระวังที่สมเหตุสมผล ข้อมูลที่เป็นความลับเป็นข้อมูลที่ไม่ใช่สาธารณะที่กำหนดให้เป็นความลับโดย NOAM หรือควรได้รับการปฏิบัติอย่างเป็นความลับอย่างสมเหตุสมผลภายใต้สถานการณ์รวมถึงซอฟต์แวร์ข้อกำหนดและข้อมูลธุรกิจที่ไม่ใช่สาธารณะอื่น ๆ ข้อมูลที่เป็นความลับไม่รวมถึงข้อมูลที่: (1) โดยทั่วไปจะมีให้ประชาชนโดยไม่มีข้อผิดพลาดในส่วนของคุณ (2) คุณมีอยู่ในความครอบครองของคุณโดยไม่มีข้อผูกมัดใด ๆ ในการรักษาความลับก่อนที่จะได้รับภายใต้ข้อกำหนดเหล่านี้ (3) มีการเปิดเผยอย่างถูกกฎหมายกับคุณโดยบุคคลที่สามโดยไม่มีภาระผูกพันในการรักษาความลับใด ๆ หรือ (4) ได้รับการพัฒนาอย่างอิสระโดยคุณโดยไม่ต้องใช้ข้อมูลที่เป็นความลับ คุณอาจเปิดเผยข้อมูลที่เป็นความลับหากกำหนดโดยกฎหมายศาลหรือคำสั่งของรัฐบาลอื่น ๆ แต่คุณต้องแจ้งล่วงหน้าเป็นลายลักษณ์อักษรถึง NoAM ในลักษณะที่สมเหตุสมผลและในขอบเขตที่เป็นไปได้พยายามอย่างสมเหตุสมผลในการ จำกัด ขอบเขตการเปิดเผยรวมถึงการช่วยเหลือเราในการร้องขอการเปิดเผย',
    block16:
      '(b) ความปลอดภัย คุณต้องใช้มาตรการที่เหมาะสมและเหมาะสมเพื่อช่วยปกป้องการเข้าถึงและการใช้บริการของคุณ หากคุณค้นพบช่องโหว่หรือการละเมิดที่เกี่ยวข้องกับการใช้บริการของคุณคุณต้องติดต่อ NoAM ทันทีและให้รายละเอียดเกี่ยวกับช่องโหว่หรือการละเมิด',
    block17:
      '((c) การประมวลผลข้อมูลส่วนบุคคลหากคุณใช้บริการเพื่อประมวลผลข้อมูลส่วนบุคคลคุณต้องให้คำสั่งความเป็นส่วนตัวที่ถูกต้องตามกฎหมายและได้รับความยินยอมที่จำเป็นสำหรับการประมวลผลข้อมูลดังกล่าวและคุณรับประกันกับเราว่าคุณจัดการข้อมูลดังกล่าวตามกฎหมายที่ใช้บังคับ',
    block18:
      '(a) การเลิกจ้าง; ระบบกันสะเทือน ข้อกำหนดเหล่านี้จะมีผลตั้งแต่การใช้บริการครั้งแรกของคุณและจะยังคงมีผลจนกว่าจะสิ้นสุด คุณสามารถยกเลิกข้อกำหนดเหล่านี้ได้ตลอดเวลาด้วยเหตุผลใดก็ตามโดยหยุดการใช้บริการและเนื้อหา เราอาจยกเลิกข้อกำหนดเหล่านี้โดยแจ้งให้ทราบล่วงหน้าไม่ว่าด้วยเหตุผลใดก็ตาม เราอาจยกเลิกข้อกำหนดเหล่านี้ได้ทันทีโดยแจ้งให้คุณทราบว่าคุณละเมิดส่วนที่ 2 (ข้อกำหนดการใช้งาน) อย่างมีนัยสำคัญส่วนที่ 5 (การรักษาความลับความปลอดภัยและการปกป้องข้อมูล) มาตรา 8 (การระงับข้อพิพาท) หรือมาตรา 9 (ข้อกำหนดทั่วไป) หรือความสัมพันธ์ของเรากับผู้ให้บริการเทคโนโลยีบุคคลที่สามนอกเหนือจากการเปลี่ยนแปลงการควบคุมของเรา เราอาจระงับการเข้าถึงบริการของคุณหากคุณไม่ปฏิบัติตามข้อกำหนดเหล่านี้หรือหากการใช้งานของคุณมีความเสี่ยงด้านความปลอดภัยต่อเราหรือบุคคลที่สามหรือหากเราสงสัยว่าการใช้งานของคุณเป็นการหลอกลวงหรืออาจทำให้เราหรือบุคคลที่สามต้องรับผิดชอบ',
    block19:
      '(b) ผลของการเลิกจ้าง เมื่อสิ้นสุดคุณจะหยุดใช้บริการและส่งคืนหรือทำลายข้อมูลที่เป็นความลับทันทีตามที่เรากำหนด บทบัญญัติของข้อกำหนดเหล่านี้ว่าโดยธรรมชาติของพวกเขาควรอยู่รอดในการเลิกจ้างหรือหมดอายุรวมถึง แต่ไม่ จำกัด เฉพาะส่วนที่ 3 และ 5-9 จะอยู่รอด',
    block2:
      'ข้อกำหนดการใช้งานเหล่านี้ใช้กับการใช้บริการของ NOAM ของคุณรวมถึงอินเทอร์เฟซการเขียนโปรแกรมแอปพลิเคชันซอฟต์แวร์เครื่องมือบริการนักพัฒนาข้อมูลข้อมูลเอกสารและเว็บไซต์ (เรียกรวมกันว่า "บริการ") โดยการใช้บริการของเราคุณตกลงที่จะปฏิบัติตามข้อกำหนดเหล่านี้ นโยบายความเป็นส่วนตัวของเราอธิบายวิธีที่เรารวบรวมและใช้ข้อมูลส่วนบุคคล',
    block20:
      '(a) การชดใช้ค่าเสียหาย คุณจะปกป้องชดใช้ค่าเสียหายและถือเรา บริษัท ในเครือของเราและบุคลากรของเราไม่เป็นอันตรายจากและต่อต้านการเรียกร้องการสูญเสียและค่าใช้จ่ายใด ๆ (รวมถึงค่าธรรมเนียมทนายความ) ที่เกิดขึ้นจากหรือเกี่ยวข้องกับการใช้บริการรวมถึงเนื้อหาการใช้ผลิตภัณฑ์หรือบริการที่เกี่ยวข้องกับบริการและการละเมิดข้อกำหนดเหล่านี้',
    block21:
      '(b) ข้อจำกัดความรับผิดชอบ บริการมีให้ "ตามสภาพ" ตามขอบเขตที่กฎหมายอนุญาตเราและ บริษัท ในเครือและผู้ออกใบอนุญาตของเราไม่ได้เป็นตัวแทนหรือการรับประกันใด ๆ เกี่ยวกับการบริการและไม่รับประกันรวมถึง แต่ไม่ จำกัด เพียงการรับประกันความสามารถในการค้าการออกกำลังกายเพื่อวัตถุประสงค์เฉพาะคุณภาพที่น่าพอใจ เราไม่รับประกันว่าบริการจะไม่หยุดชะงักถูกต้องหรือปราศจากข้อผิดพลาดหรือว่าเนื้อหาใด ๆ จะปลอดภัยไม่สูญหายหรือไม่เปลี่ยนแปลง',
    block22:
      '(c) ข้อ จำกัด ของความรับผิด ทั้งเราในเครือและผู้ออกใบอนุญาตของเราจะไม่รับผิดชอบต่อความเสียหายทางอ้อม, โดยบังเอิญ, พิเศษ, ผลสืบเนื่อง, หรือค่าธรรมเนียมการลงโทษรวมถึงการสูญเสียผลกำไรการสูญเสียชื่อเสียงการสูญเสียการใช้งานการสูญเสียข้อมูลหรือการสูญเสียที่ไม่มีตัวตนอื่น ๆ ภายใต้ข้อกำหนดเหล่านี้ความรับผิดทั้งหมดของเราจะไม่เกินค่าธรรมเนียมที่คุณจ่ายให้กับบริการในสิบสอง (12) เดือนก่อนการเรียกร้องหรือหนึ่งร้อยดอลลาร์สหรัฐ ($ 100) แล้วแต่จำนวนใดจะสูงกว่า ข้อ จำกัด ในส่วนนี้ใช้กับขอบเขตสูงสุดที่อนุญาตโดยกฎหมายที่บังคับใช้',
    block23:
      'ข้อกำหนดและการใช้บริการของคุณอยู่ภายใต้กฎหมายของสหรัฐอเมริกายกเว้นกฎความขัดแย้งทางกฎหมายของสหรัฐอเมริกา การใช้แอปพลิเคชันของคุณอาจอยู่ภายใต้กฎหมายท้องถิ่นรัฐรัฐหรือนานาชาติอื่น ๆ การดำเนินการทางกฎหมายหรือการดำเนินการใด ๆ ที่เกี่ยวข้องกับข้อกำหนดเหล่านี้จะถูกนำมาใช้เฉพาะในศาลของสหรัฐอเมริกาและคุณตกลงที่จะส่งไปยังเขตอำนาจศาลส่วนบุคคลของศาลดังกล่าว',
    block24:
      '(a) ความสัมพันธ์ของคู่กรณี Noam และคุณเป็นผู้รับเหมาอิสระและไม่มีฝ่ายใดมีอำนาจในการเป็นตัวแทนหรือผูกมัดอีกฝ่ายหรือถือว่าภาระผูกพันสำหรับอีกฝ่ายโดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจากอีกฝ่าย',
    block25:
      '(b) การใช้แบรนด์ คุณไม่สามารถใช้ชื่อโลโก้หรือเครื่องหมายการค้าของ NOAM หรือ บริษัท ในเครือใด ๆ โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรก่อน',
    block26:
      'หากข้อกำหนดใด ๆ ของข้อกำหนดเหล่านี้ถูกกำหนดให้ไม่ถูกต้องผิดกฎหมายหรือไม่สามารถบังคับใช้ได้บทบัญญัติที่เหลือจะยังคงมีผลบังคับใช้และผลกระทบอย่างเต็มที่',
    block3:
      'หากคุณอายุต่ำกว่า 18 ปีคุณต้องได้รับอนุญาตจากพ่อแม่หรือผู้ปกครองตามกฎหมายให้ใช้บริการ หากคุณใช้บริการในนามของบุคคลหรือนิติบุคคลอื่นคุณต้องได้รับอนุญาตให้ยอมรับข้อกำหนดเหล่านี้ในนามของพวกเขา คุณต้องให้ข้อมูลที่ถูกต้องและสมบูรณ์เพื่อลงทะเบียนสำหรับบัญชี คุณไม่สามารถให้ข้อมูลรับรองการเข้าถึงหรือบัญชีของคุณแก่ทุกคนที่อยู่นอกองค์กรของคุณและคุณต้องรับผิดชอบกิจกรรมทั้งหมดที่ดำเนินการโดยใช้ข้อมูลรับรองของคุณ',
    block4:
      '(a) การใช้บริการ คุณสามารถเข้าถึงบริการภายใต้ข้อกำหนดเหล่านี้และเราให้สิทธิ์ที่ไม่ผูกขาดในการใช้บริการ เมื่อใช้บริการคุณจะปฏิบัติตามข้อกำหนดเหล่านี้และกฎหมายที่เกี่ยวข้องทั้งหมด เราและ บริษัท ในเครือของเราเป็นเจ้าของสิทธิ์ชื่อและผลประโยชน์ทั้งหมดในการให้บริการ',
    block5:
      '(b) ข้อเสนอแนะ เรายินดีรับข้อเสนอแนะความคิดเห็นความคิดคำแนะนำและการปรับปรุง หากคุณให้เนื้อหาดังกล่าวเราอาจใช้มันโดยไม่มีข้อ จำกัด ใด ๆ และไม่มีการชดเชยให้คุณ',
    block6:
      '(c) ข้อ จำกัด คุณไม่สามารถ: (1) ใช้บริการในลักษณะที่ละเมิดการยักยอกหรือละเมิดสิทธิ์ใด ๆ ของผู้อื่น (2) วิศวกรย้อนกลับ, ถอดรหัส, ถอดแยก, แปลหรือพยายามค้นหาซอร์สโค้ดหรือส่วนประกอบพื้นฐานของแบบจำลองการบริการอัลกอริทึมและระบบ (เว้นแต่ว่าข้อ จำกัด ดังกล่าวจะถูกห้ามตามกฎหมายที่ใช้บังคับ); (3) ใช้ผลลัพธ์ของบริการเพื่อพัฒนาโมเดลที่แข่งขันกับ NOAM (4) แยกข้อมูลหรือผลลัพธ์จากบริการโดยใช้วิธีการอัตโนมัติหรือวิธีการเขียนโปรแกรมเว้นแต่จะได้รับอนุญาตผ่าน API รวมถึงการขูดการเก็บเกี่ยวเว็บหรือการสกัดข้อมูลเว็บ (5) แสดงถึงผลลัพธ์ของการบริการที่สร้างขึ้นเมื่อไม่ได้หรือละเมิดนโยบายการใช้งานของเรา (6) การซื้อขายหรือโอนคีย์ API โดยไม่ได้รับความยินยอมจากเราก่อน หรือ (7) ให้ข้อมูลส่วนบุคคลเกี่ยวกับเด็กอายุต่ำกว่า 13 ปีหรือมีความยินยอมจากดิจิทัล คุณจะปฏิบัติตามขีด จำกัด อัตราและข้อกำหนดอื่น ๆ ในเอกสารของเรา',
    block7:
      '(d) บริการของบุคคลที่สาม ซอฟต์แวร์บริการหรือผลิตภัณฑ์อื่น ๆ ที่เกี่ยวข้องกับบริการของบุคคลที่สามใด ๆ จะถูกควบคุมโดยข้อกำหนดของตนเองและเราจะไม่รับผิดชอบต่อผลิตภัณฑ์ของบุคคลที่สาม',
    block8:
      '(a) เนื้อหาของคุณ คุณอาจให้อินพุต ("อินพุต") ไปยังบริการและรับเอาต์พุต ("เอาต์พุต") ที่สร้างและส่งคืนตามอินพุต (เรียกรวมกันว่า "เนื้อหา") ระหว่างคู่สัญญาและตามขอบเขตที่กฎหมายบังคับใช้คุณเป็นเจ้าของข้อมูลทั้งหมด NOAM อาจใช้เนื้อหาเพื่อให้และบำรุงรักษาบริการปฏิบัติตามกฎหมายที่บังคับใช้และบังคับใช้นโยบายของเรา คุณต้องรับผิดชอบต่อเนื้อหารวมถึงการทำให้มั่นใจว่าจะไม่ละเมิดกฎหมายที่เกี่ยวข้องหรือข้อกำหนดเหล่านี้',
    block9:
      '(b) ความแม่นยำ ปัญญาประดิษฐ์และการเรียนรู้ของเครื่องจักรกำลังพัฒนาอย่างรวดเร็วสาขาการวิจัย เรามุ่งมั่นที่จะปรับปรุงการบริการของเราอย่างต่อเนื่องเพื่อให้มีความแม่นยำมากขึ้นเชื่อถือได้ปลอดภัยและเป็นประโยชน์ เมื่อพิจารณาถึงลักษณะที่น่าจะเป็นของการเรียนรู้ของเครื่องจักรการใช้บริการของเราอาจส่งผลให้เกิดผลลัพธ์ที่ไม่ถูกต้องในบางกรณีซึ่งอาจไม่สะท้อนถึงบุคคลสถานที่หรือข้อเท็จจริงที่แท้จริง คุณควรประเมินความถูกต้องของผลลัพธ์ใด ๆ ตามกรณีการใช้งานของคุณรวมถึงการตรวจสอบผลลัพธ์ด้วยตนเอง',
    subTitle1: 'การลงทะเบียนและการเข้าถึง',
    subTitle10: 'ความสามารถในการแยกได้',
    subTitle2: 'ข้อกำหนดการใช้งาน',
    subTitle3: 'เนื้อหา',
    subTitle4: 'ค่าธรรมเนียมและการชำระเงิน',
    subTitle5: 'การรักษาความลับความปลอดภัยและการปกป้องข้อมูล',
    subTitle6: 'เทอมและการเลิกจ้าง',
    subTitle7: 'การชดใช้ค่าเสียหาย; ข้อจำกัดความรับผิดชอบ; ข้อ จำกัด ของความรับผิด',
    subTitle8: 'กฎหมายและเขตอำนาจศาล',
    subTitle9: 'ข้อกำหนดทั่วไป',
    title: 'ข้อกำหนด',
    updateTime: 'อัปเดต: 15 มีนาคม 2567',
  },
  trialModal: {
    btn: 'เริ่มต้นตอนนี้ （เพียง $ 0.99)',
    chat: 'chatpdf',
    desc1: 'หลังจากการทดลองของคุณคุณจะถูกเรียกเก็บค่าธรรมเนียมรายปี $ 180',
    desc2: 'ยกเลิกได้ตลอดเวลา',
    focus: 'การโฟกัส',
    hover: 'การแปลโฮเวอร์',
    image: 'การแปลภาพ',
    installBtn: 'ติดตั้งตอนนี้เพื่อรับของขวัญของคุณ',
    memo: 'การจัดการรายการโปรด',
    pdf: 'การแปลแบบขนาน PDF',
    realtime: 'การแปลทันที',
    select: 'คำแปลการเลือกคำ',
    title: 'ต้อนรับของขวัญ',
    trialText: 'การทดลอง 7 วัน',
    video: 'การแปลวิดีโอ',
    videoSummary: 'สรุปวิดีโอ',
    web: 'การแปลแบบขนาน',
    webSummary: 'สรุปเว็บ',
  },
  upgradeModal: {
    btn: 'อัพเกรดตอนนี้',
    chat: { free: 'คุณมาถึงขีด จำกัด chatpdf', pro: 'คุณมาถึงขีด จำกัด chatpdf สำหรับเดือนนี้' },
    contactStr: 'โปรดรอการรีเซ็ตครั้งต่อไปหรือติดต่อเราที่ contact@noam.tools',
    limitAlertStr: 'คุณถึงขีด จำกัด แผนฟรีแล้ว อัพเกรดเพื่อดำเนินการต่อ',
    more: 'ดูแผน',
    pageLimit: { free: 'คุณมาถึงขีด จำกัด หน้า PDF' },
    title: 'เตือนความจำ',
    upgradeAlertStr: 'คุณถึงขีด จำกัด แผนฟรีแล้ว อัพเกรดเพื่อดำเนินการต่อ',
    upload: {
      free: 'คุณถึงขีด จำกัด การแปล PDF ของคุณแล้ว',
      pro: 'คุณถึงขีด จำกัด การแปล PDF ของคุณสำหรับเดือนนี้',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'เข้าร่วมตอนนี้',
      label: 'ผลประโยชน์ของผู้ใช้ใหม่:',
      remain: 'เหลือเพียง 30',
      text: 'มีเพียง 100 จุดเท่านั้น! คว้าของคุณตอนนี้!',
    },
  },
  aiPdfTranslator: {
    title: 'แปล PDF ด้วย AI ฟรี: แปล PDF และเปรียบเทียบข้อความได้ทุกภาษา',
    desc: 'แปลไฟล์ PDF เป็นภาษาต่าง ๆ ได้อย่างง่ายดายด้วย AI เปรียบเทียบข้อความต้นฉบับและที่แปลแล้วแบบเคียงข้างกัน รวดเร็วและฟรี',
    keywords: 'GPT-4, ผู้ช่วย AI, การแปล, สรุป, โฟกัส, ChatPDF, บันทึก, ประสิทธิภาพ',
    sourceToTarget: {
      title: 'เครื่องมือแปล PDF ฟรี: แปล {{source}} เป็น {{target}} ได้ฟรี',
      desc: 'แปลไฟล์ PDF ของคุณจากทุกภาษาต้นทางเป็นภาษาที่คุณต้องการได้ฟรี รวดเร็ว แม่นยำ และปลอดภัยด้วยการแปล PDF ที่ขับเคลื่อนด้วย AI ขั้นสูง',
    },
    headerIntroduce: {
      title: 'Noam: มากกว่าแค่การแปลออนไลน์',
      introduce1: {
        title: 'Noam · โปรแกรมอ่าน PDF',
        desc: '✨แปลแบบเคียงข้าง + ถามตอบด้วย AI แปล PDF ของคุณเป็นภาษาที่ต้องการอย่างรวดเร็วและแม่นยำ ถามคำถามเกี่ยวกับเนื้อหาได้อิสระเพื่อเข้าใจไฟล์ PDF ของคุณได้ลึกซึ้งยิ่งขึ้น',
      },
      introduce2: {
        title: 'Noam · ส่วนขยายแปลแบบเคียงข้าง',
        desc: '👏ตอบโจทย์ทุกความต้องการแปลหน้าเว็บของคุณ:',
        detail1: { title: 'การแปลหน้าเว็บ: ', desc: 'มุมมองสองภาษาแบบเคียงข้าง' },
        detail2: { title: 'แปลคำศัพท์: ', desc: 'แปลด่วนเพียงคลิกเดียว' },
        detail3: { title: 'แปลทันที: ', desc: 'แปลคำหรือประโยคได้ทันที' },
        detail4: { title: 'แปลรูปภาพ: ', desc: 'แทนที่รูปภาพด้วยเวอร์ชันที่แปลแล้ว' },
        detail5: { title: 'แปลวิดีโอ: ', desc: 'คำบรรยายสองภาษาเพื่อการรับชมที่ดียิ่งขึ้น' },
        footer: 'สัมผัสฟีเจอร์การอ่านอัจฉริยะด้วย AI สำหรับการแปลที่ฉลาดขึ้น!',
      },
    },
    subtitle: 'แปล PDF ออนไลน์ฟรี',
    introduce: {
      module1: {
        detail1: {
          title: 'แปล PDF แบบเรียลไทม์เคียงข้าง',
          desc1: 'แสดงเนื้อหาต้นฉบับและที่แปลแล้วทันทีในรูปแบบเคียงข้างอย่างซิงค์กัน',
          desc2: 'เปรียบเทียบสองเวอร์ชันได้ง่าย ๆ ด้วยการเลื่อนแบบซิงค์',
          desc3: 'คงรูปแบบเดิมเพื่อประสบการณ์การอ่านที่ต่อเนื่อง',
        },
        detail2: {
          title: 'จัดแนวเนื้อหาแม่นยำและตรวจสอบง่าย',
          desc1: 'จัดวางเนื้อหาต้นฉบับและที่แปลอย่างแม่นยำเพื่อการตรวจสอบที่สะดวก',
          desc2: 'แต่ละส่วนของเนื้อหาตรงกันในทั้งสองเวอร์ชัน',
          desc3: 'ค้นพบและแก้ไขข้อแตกต่างในการแปลได้อย่างรวดเร็วเพื่อผลลัพธ์ที่เชื่อถือได้',
        },
      },
      module2: {
        detail1: {
          title: 'โมเดล AI ขั้นสูงหลากหลายสำหรับการแปลที่แม่นยำ',
          desc1: 'เลือกโมเดล AI ชั้นนำให้ตรงกับความต้องการของคุณ',
          desc2: 'มั่นใจได้ว่าผลลัพธ์ดีที่สุดสำหรับเอกสารและอุตสาหกรรมทุกรูปแบบ',
          desc3: 'ตัวเลือกโมเดลที่ยืดหยุ่น รองรับทุกสถานการณ์',
        },
        detail2: {
          title: 'AI แปลขั้นสูงสำหรับเนื้อหาทุกประเภท',
          desc1: 'โมเดล AI อันทรงพลังของเรามีความแม่นยำสูงและเข้าใจภาษาได้อย่างเป็นธรรมชาติ',
          desc2: 'รองรับเอกสารเชิงเทคนิค วิชาการ และสร้างสรรค์ได้อย่างง่ายดาย',
          desc3: 'ให้ผลลัพธ์ที่น่าเชื่อถือสำหรับทุกความต้องการในการแปล',
          desc4: 'ปรับให้เหมาะสมกับแต่ละประเภทเนื้อหาอย่างชาญฉลาดเพื่อประสิทธิภาพสูงสุด',
        },
      },
      module3: {
        detail1: {
          title: 'โต้ตอบกับเอกสารอย่างชาญฉลาด',
          desc1: 'สนทนากับไฟล์ PDF และงานนำเสนอของคุณได้อย่างง่ายดายด้วย AI ขั้นสูง',
          desc2: 'ถามคำถามเกี่ยวกับเนื้อหาและรับคำตอบที่ถูกต้องได้ทันที',
          desc3: 'สร้างสรุปใจความสำคัญของเอกสารยาว ๆ ได้อย่างรวดเร็ว',
        },
        detail2: {
          title: 'วิเคราะห์เนื้อหาเชิงลึกและบูรณาการอย่างไร้รอยต่อ',
          desc1: 'ดึงข้อมูลสำคัญและวิเคราะห์ข้อมูลซับซ้อนด้วย AI',
          desc2: 'รับข้อมูลเชิงลึกจากเนื้อหาเทคนิค วิชาการ หรือสร้างสรรค์',
          desc3: 'บูรณาการเข้ากับตัวแปล PDF ของเราได้อย่างไร้รอยต่อสำหรับการจัดการเอกสารแบบครบวงจร',
        },
      },
      module4: {
        detail1: {
          title: 'มากกว่าแค่แปล PDF: โซลูชันแปลเว็บเพจครบวงจร',
          desc: 'ค้นพบส่วนขยายแปลแบบเคียงข้างที่ทรงพลังของเรา สำหรับทุกสถานการณ์การอ่านออนไลน์',
          desc1: 'การแปลหน้าเว็บ: เพลิดเพลินกับเนื้อหาสองภาษาในมุมมองเคียงข้างอย่างซิงค์กัน',
          desc2: 'แปลคำศัพท์: แปลคำที่ไฮไลท์ทันทีด้วยคลิกเดียว',
          desc3: 'แปลทันที: แปลข้อความหรือประโยคใด ๆ ได้ทันทีเพื่อความเข้าใจรวดเร็ว',
          desc4: 'แปลรูปภาพ: แทนที่รูปต้นฉบับโดยอัตโนมัติด้วยเวอร์ชันที่แปลแล้ว',
          desc5: 'แปลวิดีโอ: รับชมวิดีโอพร้อมคำบรรยายสองภาษาเพื่อประสบการณ์ที่เหนือกว่า',
        },
      },
    },
    question: {
      title: 'คำถามที่พบบ่อย',
      answer1: {
        title: 'Noam PDF Translator ใช้แปล PDF ได้ฟรีหรือไม่?',
        content:
          'ใช่ คุณสามารถแปล PDF ได้ฟรีด้วย Sider PDF Translator! เราให้โควต้าฟรี 5,000 โทเคน ซึ่งเพียงพอสำหรับ PDF ส่วนใหญ่ในท้องตลาด หากต้องการแปลไฟล์ขนาดใหญ่หรือฟีเจอร์ขั้นสูงเพิ่มเติม คุณสามารถอัปเกรดเป็นแพ็กเกจพรีเมียมเพื่อความสามารถที่มากกว่าเดิม',
      },
      answer2: {
        title: 'Noam PDF Translator แปลแม่นยำแค่ไหน?',
        content:
          'Noam PDF Translator ให้การแปลที่แม่นยำสูงด้วยเทคโนโลยี AI ขั้นสูงและเข้าใจบริบทของเอกสารคุณอย่างลึกซึ้ง แม้ว่าการแปลอัตโนมัติจะไม่สมบูรณ์แบบเสมอไป แต่มุมมองแบบเคียงข้างของเราช่วยให้คุณตรวจสอบและปรับแต่งการแปลได้ง่าย เพื่อให้ผลงานสุดท้ายตรงกับมาตรฐานที่คุณต้องการ สัมผัสการแปล PDF ที่เชื่อถือได้และแม่นยำกับ Noam',
      },
      answer3: {
        title: 'สามารถแปล PDF ที่สแกนได้ไหม?',
        content:
          'ได้ คุณสามารถแปล PDF ที่สแกนได้ด้วยเทคโนโลยี OCR (Optical Character Recognition) ที่ฝังในระบบของเรา ระบบจะดึงข้อความจากเอกสารสแกนหรือ PDF ที่เป็นภาพโดยอัตโนมัติ แล้วแปลเนื้อหาให้คุณ ทำให้แม้แต่ PDF ที่แก้ไขไม่ได้หรือมีแต่ภาพก็สามารถแปลได้อย่างถูกต้อง',
      },
      answer4: {
        title: 'ใช้เวลานานแค่ไหนในการแปล?',
        content:
          'การแปลทำได้อย่างรวดเร็วและมีประสิทธิภาพ — ส่วนใหญ่ใช้เวลาแค่ไม่กี่วินาทีถึงไม่กี่นาที ขึ้นอยู่กับความยาวและความซับซ้อน เช่น PDF มาตรฐาน 10 หน้า มักใช้เวลาไม่ถึง 2 นาทีในการแปล เพลิดเพลินกับความรวดเร็วสำหรับทุกความต้องการของคุณ!',
      },
      answer5: {
        title: 'สามารถอ่านเอกสารแบบเคียงข้างกันได้ตลอดไหม?',
        content:
          'ได้ คุณสามารถอ่านเอกสารแบบเคียงข้างได้เสมอ รูปแบบนี้ช่วยให้เปรียบเทียบเนื้อหาต้นฉบับกับที่แปลได้ง่าย เพื่อประสบการณ์การอ่านที่ราบรื่นและมีประสิทธิภาพ',
      },
    },
    freeTrial: 'ทดลองใช้ฟรี',
    toLanguage: { title: '{{lang}} คู่แปล PDF AI', item: '{{source}} เป็น {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'บล็อก',
      pricing: 'การกำหนดราคา',
      faq: 'คำถามที่พบบ่อย',
      button: 'แปลทันที',
      features: 'คุณสมบัติ',
    },
    hero: {
      upload: {
        title: 'อัปโหลดไฟล์ PDF ของคุณ',
        desc: 'หรือลากและวาง',
        highlight: 'คลิกเพื่อเรียกดู',
        max: 'แม็กซ์',
      },
      to: 'ไปยัง',
      title: 'แปล PDF ฟรี',
      pill: 'เครื่องแปล PDF ที่ใช้เทคโนโลยี AI',
      model: 'GPT-4 และ Claude',
      desc: 'การแปลทันทีแม่นยำที่รักษาเลย์เอาต์ดั้งเดิม Noam AI รองรับ OCR และมุมมองแบบเคียงข้างกัน',
      translated: 'แปลโดยโนแอม',
      free: 'ทดลองใช้ฟรี',
      support: 'การสนับสนุน OCR',
      complete: 'การแปลเสร็จสมบูรณ์',
    },
    ticker: {
      ocr: 'เทคโนโลยี OCR',
      pdf: 'การแปล PDF',
      format: 'การรักษารูปแบบ',
      side: 'ติดกันข้างๆ',
      web: 'การแปลเว็บ',
      chat: 'แชทกับ PDF',
      multi: 'หลายภาษา',
      secure: 'ปลอดภัยและเป็นส่วนตัว',
    },
    comparison: {
      bad: {
        title: 'การแปลมาตรฐาน',
        head: 'การสูญเสียรูปแบบและบริบท',
        text1: 'ข้อผิดพลาด: รูปแบบที่พัง. รูปภาพถูกวางผิดตำแหน่ง',
        text2: 'ข้อความทับซ้อนกันและแบบอักษรไม่สอดคล้องกัน ยากอ่านและไม่มีระดับมืออาชีพ...',
      },
      dump: { title: 'การส่งออกข้อความธรรมดา' },
      good: {
        title: 'การแปล AI Noam',
        sub: 'การจัดรูปแบบที่สมบูรณ์แบบ ทราบที่มาของบริบท',
        tag: 'ผลลัพธ์สมบูรณ์แบบ',
      },
      title: 'ทำไมต้องเลือก Noam AI?',
      desc: 'หยุดสู้รักการแปลแบบคัดลอก-วางแล้วล่ะ สัมผัสความแตกต่างระหว่างเครื่องมือมาตรฐานกับการแปลที่มีความรู้สึกถึงบริบทอาศัยช่วยเหลือจาก AI ของเรา',
    },
    showcase: {
      kicker: 'เอกสารที่รองรับ',
      title2: 'ภาษาใด ๆ',
      title1: 'เอกสารใดๆ',
      carousel1: 'ศิลปะ',
      carousel2: 'สถาปัตยกรรม',
      carousel4: 'ยา',
      carousel3: 'วารสารวิชาการ',
      carousel6: 'กฎหมาย',
      carousel5: 'การเงิน',
      carousel7: 'สัญญา',
      note: 'จัดการเอกสารทางเทคนิค เอกสารทางวิชาการ และเอกสารสร้างสรรค์ได้อย่างง่ายดาย',
      carousel8: 'นโยบาย',
    },
    features: {
      big: {
        title: 'โมเดล AI ขั้นสูง (GPT-4, Claude)',
        desc: 'เลือกจากโมเดล AI ที่领先 เพื่อตรงกับความต้องการในการแปลของคุณ รับประกันผลลัพธ์ที่เหมาะสมที่สุดสำหรับเอกสารประเภทต่างๆ',
      },
      grid1: { title: 'การสนับสนุน OCR', desc: 'สกัดและแปลข้อความจาก PDF ที่สแกนและรูปภาพทันที' },
      grid2: {
        title: 'ส่งออกความละเอียดสูง',
        desc: 'ดาวน์โหลดเอกสารที่แปลแล้วในรูปแบบ PDF พร้อมเลย์เอาต์เดิม',
      },
      grid3: {
        title: 'การเปรียบเทียบแบบข้างเคียง',
        desc: 'การเลื่อนแบบซิงโครไนซ์เพื่อเปรียบเทียบข้อความต้นฉบับและข้อความแปล',
      },
      title1: 'ไม่เพียงแค่การแปล而已',
      title2: 'มันคือการปฏิวัติ',
      line1: 'เอกสารเทคนิค.pdf',
      line2: 'กำลังตรวจจับภาษา: อังกฤษ...',
      line4: 'การแปลเสร็จสมบูรณ์ (ความถูกต้อง 99%)',
      line3: 'รุ่น: GPT-4o (ความแม่นยำสูง)',
    },
    testimonials: {
      review1: {
        role: 'นักวิจัย',
        content:
          'Noam AI ช่วยฉันประหยัดเวลาหลายชั่วโมงในการแปลเอกสารวิชาการ มุมมองแบบเคียงข้างมีประโยชน์อย่างมากสำหรับการตรวจสอบคำศัพท์ทางเทคนิค',
      },
      review2: {
        role: 'นักตลาดโลก',
        content:
          'เครื่องมือแปล PDF ที่ดีที่สุดที่ฉันเคยใช้ มันรักษารูปแบบเดิมได้อย่างสมบูรณ์ ซึ่งมีความสำคัญอย่างยิ่งสำหรับเด็คการตลาดของเรา',
      },
      review3: {
        role: 'ที่ปรึกษาทางกฎหมาย',
        content:
          'ถูกต้องและรวดเร็ว ฉันใช้มันสำหรับการแปลสัญญา และฟีเจอร์ OCR สำหรับเอกสารที่สแกนแล้วทำงานได้อย่างสมบูรณ์แบบ',
      },
      kicker: 'เป็นที่ชื่นชอบของผู้ใช้',
      title: 'สิ่งที่ผู้ใช้ของเราเขียน',
    },
    cta: {
      title: 'พร้อมที่จะทำลายอุปสรรคทางภาษาแล้วหรือไม่?',
      desc: 'เข้าร่วมผู้ใช้งานกว่า 10,000 คนและเริ่มแปลเอกสารของคุณด้วย Noam AI วันนี้',
      button: 'เริ่มแปลฟรีเลย',
      hint: 'แปลเนื้อหาต่อไปนี้เป็นภาษาไทยที่ถูกต้องและสไตล์ปกติ:',
    },
    languagePairs: {
      title: 'คู่การแปล PDF อังกฤษด้วย AI',
      desc: 'ทิศทางการแปลที่ได้รับความนิยมที่ Noam AI รองรับ',
    },
    footer: {
      about: 'เกี่ยวกับเรา',
      privacy: 'นโยบายความเป็นส่วนตัว',
      contact: 'ติดต่อฝ่ายสนับสนุน',
    },
  },
}

export default TRANSLATION
